export type FacturacionForm = {
    tipo_comprobante: TipoComprobante;
    correo: string;
    correo_copia?: string;
    direccion: string;
    ubigeo: string;
    nombre_comercial: string;
    nombre_legal: string;
    tipo_documento_identidad: TipoDocSunat;
    numero_documento_identidad: string;
};

export type TipoComprobante = "Factura" | "Boleta";
export type TipoDocSunat =
    | "DOC_TRIB_NO_DOM_SIN_RUC"
    | "DOC_NACIONAL_DE_IDENTIDAD"
    | "CARNET_DE_EXTRANJERIA"
    | "RUC"
    | "PASAPORTE"
    | "CED_DIPLOMATICA_IDENTIDAD";

export const DOC_OPCIONES: { value: TipoDocSunat; label: string }[] = [
    {
        value: "DOC_TRIB_NO_DOM_SIN_RUC",
        label: "DOC_TRIB_NO_DOM_SIN_RUC (Extranjero sin RUC)",
    },
    {
        value: "DOC_NACIONAL_DE_IDENTIDAD",
        label: "DOC_NACIONAL_DE_IDENTIDAD (DNI)",
    },
    { value: "CARNET_DE_EXTRANJERIA", label: "CARNET_DE_EXTRANJERIA" },
    // { value: "RUC", label: "RUC" },
    { value: "PASAPORTE", label: "PASAPORTE" },
    { value: "CED_DIPLOMATICA_IDENTIDAD", label: "CED_DIPLOMATICA_IDENTIDAD" },
];

export const DOC_OPCIONES_FACTURA: { value: TipoDocSunat; label: string }[] = [
    // {
    //     value: "DOC_NACIONAL_DE_IDENTIDAD",
    //     label: "DOC_NACIONAL_DE_IDENTIDAD (DNI)",
    // },

    { value: "RUC", label: "RUC" },

    // { value: "CED_DIPLOMATICA_IDENTIDAD", label: "CED_DIPLOMATICA_IDENTIDAD" },
];

export const DOC_EXTRANJERO_SIN_IGV: TipoDocSunat[] = [
    "DOC_TRIB_NO_DOM_SIN_RUC",
    "CARNET_DE_EXTRANJERIA",
    "PASAPORTE",
    "CED_DIPLOMATICA_IDENTIDAD",
];
